/* ==========================================================================
   Product form: variant selection, price/availability updates, gallery sync
   ========================================================================== */
(function () {
  'use strict';

  function initVariantPicker(root) {
    var picker = root.querySelector('variant-picker');
    if (!picker) return;

    var variantDataEl = picker.querySelector('[data-variant-data]');
    var variants = [];
    try {
      variants = JSON.parse(variantDataEl.textContent);
    } catch (e) {
      return;
    }

    var nativeSelect = picker.querySelector('[data-variant-select]');
    var hiddenInput = root.querySelector('[data-selected-variant-id]');
    var priceWrapper = root.querySelector('[data-price-wrapper]');
    var skuEl = root.querySelector('[data-product-sku]');
    var submitButton = root.querySelector('[data-add-to-cart]');
    var submitText = submitButton ? submitButton.querySelector('[data-add-to-cart-text]') : null;
    var productId = picker.getAttribute('data-product-id');

    function getSelectedOptions() {
      var options = [];
      picker.querySelectorAll('.variant-picker__option').forEach(function (optionEl) {
        var index = parseInt(optionEl.getAttribute('data-option-index'), 10);
        var selected = optionEl.querySelector('.swatch--selected, .option-button--selected');
        options[index] = selected ? selected.getAttribute('data-option-value') : null;
      });
      return options;
    }

    function findMatchingVariant(options) {
      return variants.find(function (variant) {
        return options.every(function (value, index) {
          return value == null || variant.options[index] === value;
        });
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function renderPrice(variant) {
      if (!priceWrapper) return;
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var html = '<div class="price ' + (onSale ? 'price--on-sale' : '') + ' ' + (!variant.available ? 'price--sold-out' : '') + '">';
      if (!variant.available) {
        html += '<span class="price__badge price__badge--sold-out">Sold Out</span>';
      }
      html += '<span class="price__container">';
      if (onSale) {
        html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        html += '<span class="price__sale">' + formatMoney(variant.price) + '</span>';
      } else {
        html += '<span class="price__regular">' + formatMoney(variant.price) + '</span>';
      }
      html += '</span></div>';
      priceWrapper.innerHTML = html;
    }

    function updateUIForVariant(variant) {
      if (!variant) {
        if (submitButton) {
          submitButton.disabled = true;
          if (submitText) submitText.textContent = 'Unavailable';
        }
        return;
      }

      if (hiddenInput) hiddenInput.value = variant.id;
      if (nativeSelect) nativeSelect.value = variant.id;
      renderPrice(variant);

      if (skuEl) skuEl.textContent = variant.sku ? 'SKU: ' + variant.sku : '';

      if (submitButton) {
        submitButton.disabled = !variant.available;
        if (submitText) submitText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      // Update color option-value label (e.g. "Selected: Black")
      var colorOption = picker.querySelector('.variant-picker__option[data-option-name="Color"] [data-selected-value-label]');
      if (colorOption) {
        var colorIndex = parseInt(
          picker.querySelector('.variant-picker__option[data-option-name="Color"]').getAttribute('data-option-index'),
          10
        );
        colorOption.textContent = variant.options[colorIndex] || '';
      }

      // Update canonical URL without reloading
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      document.dispatchEvent(new CustomEvent('theme:variant:change', { detail: { variant: variant, productId: productId } }));
    }

    picker.addEventListener('click', function (event) {
      var control = event.target.closest('.swatch, .option-button');
      if (!control || control.classList.contains('option-button--unavailable')) {
        if (control && control.classList.contains('option-button--unavailable')) {
          // allow selecting unavailable combos to show "sold out" state, don't block UI
        } else {
          return;
        }
      }
      if (!control) return;

      var optionGroup = control.closest('.variant-picker__option');
      optionGroup.querySelectorAll('.swatch, .option-button').forEach(function (el) {
        el.classList.remove('swatch--selected', 'option-button--selected');
        el.setAttribute('aria-pressed', 'false');
      });
      control.classList.add(control.classList.contains('swatch') ? 'swatch--selected' : 'option-button--selected');
      control.setAttribute('aria-pressed', 'true');

      var options = getSelectedOptions();
      var matched = findMatchingVariant(options);
      updateUIForVariant(matched);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-info]').forEach(initVariantPicker);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  /* Quantity steppers used outside the cart (PDP) ----------------------*/
  document.addEventListener('click', function (event) {
    var decrease = event.target.closest('#ProductForm [data-quantity-decrease]');
    var increase = event.target.closest('#ProductForm [data-quantity-increase]');
    if (!decrease && !increase) return;
    var wrapper = (decrease || increase).closest('[data-quantity-input]');
    var input = wrapper.querySelector('[data-quantity-field]');
    var value = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    value = decrease ? Math.max(min, value - 1) : value + 1;
    input.value = value;
  });
})();
